import type { HTMLAttributes } from 'react';
import './Skeleton.css';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'circle' | 'rect';
  width?: string | number;
  height?: string | number;
}

/** Loading-state placeholder. `aria-hidden` — it stands in for content that
 * isn't there yet, so it must never be announced as if it were real content;
 * the loading region it lives in should carry its own `aria-busy`/live-region
 * announcement instead (see patterns.md's mandatory loading state). */
export function Skeleton({ variant = 'text', width, height, className, style, ...rest }: SkeletonProps) {
  return (
    <div
      className={['dpr-skeleton', `dpr-skeleton--${variant}`, className].filter(Boolean).join(' ')}
      style={{ width, height, ...style }}
      aria-hidden="true"
      {...rest}
    />
  );
}
